// extracted by mini-css-extract-plugin
export default {"wrapper":"InstagramWall_wrapper__EYi2f","instagramWallIframe":"InstagramWall_instagramWallIframe__LhPay"};